import { useEffect, useRef, useState } from 'react'

export function useMultiCountPress(callback: () => void, count: number, threshold: number) {
  const pressTimeout = useRef<NodeJS.Timeout>(undefined)

  const [pressCount, setPressCount] = useState(0)

  useEffect(() => {
    clearTimeout(pressTimeout.current)

    if (pressCount === count) {
      setPressCount(0)
      callback()
    } else if (pressCount > 0) {
      pressTimeout.current = setTimeout(() => setPressCount(0), threshold)
    }
  }, [pressCount])

  function handleClick() {
    setPressCount(prev => prev + 1)
  }

  return { onClick: handleClick }
}
